// src/components/layout/mainLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../header';
import Sidebar from '../sidebar';
import './styles.scss';

export default function MainLayout() {
  return (
    <div className="em-app">
      <Header />
      <div className="em-body">
        <Sidebar />
        <main className="em-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
